var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5.09091 10.2836L1.27273 6.20896L0 7.56716L5.09091 13L16 1.35821L14.7273 0L5.09091 10.2836Z","fill":"#0DB350"}));
}

Tick.defaultProps = {"width":"16","height":"13","viewBox":"0 0 16 13","fill":"none"};

module.exports = Tick;

Tick.default = Tick;
